import styled from 'styled-components';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1eezyv9-0"
})(["background-color:#f2f5f8;margin:0 -10px;@media (min-width:801px){margin:0 -20px;}"]);
export default Wrapper;